<template>
    <div>
        <JbPointList :biz-ctg="$config.BIZ_CATEGORY.ELEVATOR" ref="list" @link-edit="handleLinkEdit"
            @link-new="handleLinkNew" />
    </div>
</template>

<script>
import JbPointList from '@/views/omp/cleaning/point/components/JbPointList.vue'
export default {
    name: "ElevatorPointList"
    , components: {
        JbPointList
    }
    , data() {
        return {
            loading: false
            , searchFormObject: {

            }
            , gridData: {
                total: 0
                , list: []
            }
        }
    }
    , compute: {}
    , methods: {
        handleLinkEdit(data) {
          
            this.$router.push(`/omp/elevator/point/${data.id}/edit`)
        }
        , handleLinkNew() {
            this.$router.push(`/omp/elevator/point/new`)
        }
    }
    , beforeRouteEnter(to, from, next) {
        next(vm => vm.$refs.list.getList())
    }
}
</script>

<style lang="scss" scoped></style>